import { LinksSchemaType } from "../type";

export const domHotelLinksArray: LinksSchemaType = {
  main: "/",
  maintitle: "صفحه اصلی هتل داخلی",
  mainImage: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/hotel-dom-desktop.png`,
  mainImageMobile: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/hotel-dom-mobile.png`,
  otherlinks: [
    {
      title: "هتل های تهران",
      href: "/رزرو-هتل/تهران",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran.png`
    },
    {
      title: "هتل های مشهد",
      href: "/رزرو-هتل/مشهد",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/mashhad.png`
    },
    {
      title: "هتل های کیش",
      href: "/رزرو-هتل/کیش",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/kish.png`
    },
    {
      title: "هتل های شیراز",
      href: "/رزرو-هتل/شیراز",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/shiraz.png`
    },
    {
      title: "هتل های اصفهان",
      href: "/رزرو-هتل/اصفهان",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/isfahan.png`
    },
    {
      title: "هتل های تبریز",
      href: "/رزرو-هتل/تبریز",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tabriz.png`
    },
    {
      title: "هتل های قشم",
      href: "/رزرو-هتل/قشم",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/qeshm.png`
    },
    {
      title: "هتل های یزد",
      href: "/رزرو-هتل/یزد",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/yazd.png`
    },
    {
      title: "هتل های قم",
      href: "/رزرو-هتل/قم",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/qom.png`
    }
  ]
};
